// extracted by mini-css-extract-plugin
export var downArrow = "_in-0";
export var infoTooltipIcon = "_in-3";
export var label = "_in-1";
export var optionCard = "_in-4";
export var upArrow = "_in-2";